import { SetStateAction } from "react";
import { Avatar, Typography, IconButton, TextField } from "@mui/material"
import { IProduct } from "../types/types"
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

interface IShoppingListItemProps {
  product: IProduct,
  setProducts: (value: SetStateAction<IProduct[]>) => void,
  isDialog?: boolean
}

export const ShoppingListItem = ({ product, setProducts, isDialog }: IShoppingListItemProps) => {
  const { name, imageUrl, quantity, bought, unit, capacity, displayQuantity } = product

  const addProduct = (product: IProduct) => {
    setProducts((prev) => {
      const exist = prev.find((p) => p.name === product.name);
      if (exist) {
        return prev.map((p) =>
          p.name === product.name
            ? { ...p, quantity: (p.quantity || 0) + 1 }
            : p
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
  }

  const removeProduct = (product: IProduct) => {
    setProducts((prev) => {
      const exist = prev.find((p) => p.name === product.name)?.quantity;
      if (exist && exist > 1) {
        return prev.map((p) =>
          p.name === product.name
            ? { ...p, quantity: (p.quantity || 0) - 1 }
            : p
        );
      }
      return prev.filter(p => p.name !== product.name);
    });
  }

  const handleOnChange = (quantity: string, product: IProduct) => {
    setProducts((prev) => {
      return prev.map((p) =>
        p.name === product.name
          ? { ...p, displayQuantity: Number(quantity) / product.capacity }
          : p
      );
    });
  }

  const toggleBought = (product: IProduct) => {
    setProducts((prev) => {
      return prev.map((p) => ({
        ...p,
        bought: p.name === product.name ? !p.bought : !!p.bought
      }))
    })
  }
  return (
    <div style={{ display: "flex", gap: 4, alignItems: "center", justifyContent: "space-between" }}>
      <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
        {imageUrl && <Avatar slotProps={{ root: { style: { background: "#fff" } }, img: { style: { objectFit: "contain", filter: bought ? "grayscale(100%)" : undefined } } }} alt={name} src={imageUrl} variant="rounded" />}
        <Typography sx={{ textDecoration: bought ? "line-through" : undefined, textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: quantity > 0 && isDialog ? 145 : 190 }}>{name}</Typography>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        {!bought && isDialog ? (
          <>
            <IconButton onClick={() => removeProduct(product)}>
              <RemoveIcon />
            </IconButton>
            {quantity > 0 ? <TextField
              slotProps={{ htmlInput: { style: { textAlign: "center", padding: 0 } }, input: { style: { padding: 0, width: 50, height: 30 } } }}
              onChange={(e) => handleOnChange(e.target.value, product)}
              defaultValue={String((displayQuantity ?? 1) / capacity)}
            /> : quantity}
            <IconButton onClick={() => addProduct(product)}>
              <AddIcon />
            </IconButton>
            {quantity > 0 && <Typography style={{ marginLeft: 4, marginRight: unit === 'g' ? 17 : 0, display: 'inline-block' }}>{unit}</Typography>}
          </>
        ) : `${Number((displayQuantity ?? 1) * capacity).toFixed(1)} ${unit}`}
        {!isDialog && <IconButton onClick={() => toggleBought(product)}>
          {bought ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
        </IconButton>}
      </div>
    </div>
  )
}
